export const STATUS_TYPES = Object.freeze({
  INACTIVE: "INACTIVE",
  ACTIVE: "ACTIVE",
  DELETED: "DELETED",
  PENDING: "PENDING",
});
